import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'utils/I18n';
import Analytics from 'utils/analytics';
import styles from './index.scss';

const EmptyTrophyCase = ({ athleteName, followUrl }) => (
  <div className={styles.empty}>
    <div className="app-icon-wrapper">
      <div className="app-icon icon-achievement icon-xl" />
    </div>
    <p>
      <a href={followUrl}>
        {I18n.t('strava.athletes.show_public.trophy_empty_state', {
          athlete_name: athleteName
        })}
      </a>
    </p>
  </div>
);

const Trophy = ({ trophy }) => (
  <a href={`/challenges/${trophy.url}`} title={trophy.teaser}>
    {/* TODO: analytics / click tracking for trophy link  */}
    <img
      src={trophy.logo_url}
      alt={trophy.name}
      className={`${styles.trophyImage} trophy-image`}
    />

    <div className={styles.description}>
      <h4 className="mb-xs">{trophy.name}</h4>
      <time className={styles.timestamp}>{trophy.date}</time>
      <div
        className={styles.effort}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: trophy.effort }}
      />
      {trophy.rank ? <div className="rank">{trophy.rank}</div> : <div />}
    </div>
  </a>
);

const Upsell = () => (
  <div className={`${styles.upsell} media media-middle`}>
    <div className="media-body">
      <h4>{I18n.t('strava.athletes.show_public.add_trophies')}</h4>
    </div>
    <div className={`media-right ${styles.mediaRight}`}>
      <a
        className={`btn btn-white ${styles.cta}`}
        href="/challenges"
        onClick={() =>
          Analytics.trackV2({
            category: 'athletes',
            page: 'athlete_profile',
            action: 'click',
            element: 'join_challenge_button'
          })
        }
      >
        {I18n.t('strava.athletes.show_public.join_cta')}
      </a>
    </div>
  </div>
);

const Trophies = ({ trophies, athleteName, followUrl }) => (
  <div className={styles.container}>
    <h3>{I18n.t('strava.athletes.show_public.trophy_case')}</h3>

    {trophies.length >= 1 ? (
      <ul className={styles.list}>
        {trophies.map((trophy) => (
          <li className={styles.listItem} key={trophy.challenge_id}>
            <Trophy trophy={trophy} />
          </li>
        ))}
      </ul>
    ) : (
      <EmptyTrophyCase athleteName={athleteName} followUrl={followUrl} />
    )}

    <Upsell />
  </div>
);

Trophies.propTypes = {
  trophies: PropTypes.arrayOf(PropTypes.object).isRequired,
  athleteName: PropTypes.string.isRequired,
  followUrl: PropTypes.string.isRequired
};

EmptyTrophyCase.propTypes = {
  athleteName: PropTypes.string.isRequired,
  followUrl: PropTypes.string.isRequired
};

Trophy.propTypes = {
  trophy: PropTypes.shape({
    url: PropTypes.string.isRequired,
    logo_url: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    teaser: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    effort: PropTypes.string.isRequired,
    rank: PropTypes.number.isRequired
  }).isRequired
};

export default Trophies;
